import React, { useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Fade,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import { useDispatch } from "react-redux";
import { setBottomMenuData } from "../action";

const HelpSupportPopup = ({ open=true, onClose }) => {


  const dispatch = useDispatch()

  useEffect(() => {
    if (localStorage.getItem("helpsupportFlag")) {
      dispatch(
        setBottomMenuData({
          HelpSupportPopup: true,
          new_HelpSupportPopup: true,
        })
      );
    }
  }, [dispatch]);


  if (!open) return null;
  const close=()=>{
    localStorage.setItem("helpsupportFlag",true)
  
    dispatch(
  setBottomMenuData({
    HelpSupportPopup: true,
    new_HelpSupportPopup: true
  })
);


    
  }



  return (
    <Fade in={true}>
      <Box
        sx={{
          position: "fixed",
          bottom: 70,
          right: 20,
          background: "linear-gradient(180deg, #642C34 0%, #7B1E2A 100%)",
          color: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          p: 3,
          width: "85%",
          maxWidth: 320,
          zIndex: 1000000000000,
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: -17,
            right: 30,
            width: 0,
            height: 0,
            borderLeft: "20px solid transparent",
            borderRight: "5px solid transparent",
            borderTop: "18px solid #7B1E2A",





          },
        }}
      >
        {/* Close Button */}
        <IconButton
          size="small"
          onClick={(e)=>{close()}}
          sx={{
            position: "absolute",
            top: -45,
            right: "44%",
            width:"40px",
              height:"40px",
            color: "#140000ff",
            background: "rgba(255, 255, 255, 1)",
            border:"#63333F 2px solid",
            boxShadow:"0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
            "&:hover": { background: "rgba(255, 255, 255, 1)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {/* Icon */}
        <Box display="flex" justifyContent="center" mb={1.5}>
          <HeadsetMicOutlinedIcon sx={{ fontSize: 48 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          align="center"
          fontWeight="700"
          sx={{ color: "#FFD74A" }}
        >
          New! Help & Support
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 1, color: "#fff", opacity: 0.9 }}
        >
          Need help or have questions? <br />
          Tap here for instant support
        </Typography>
      </Box>
    </Fade>
  );
};

export default HelpSupportPopup;
